// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wallet-card[data-v-77dd67cf] {\n  text-align: right;\n  font-size: 2rem;\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n  margin: 0rem 0rem 1rem 0rem;\n}\n.main-text[data-v-77dd67cf] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n  gap: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
